//==========import components===============
import ServiceCard from 'components/common/cards/ServiceCard';
import TitleSection from 'components/common/TitleSection';

const HomeServices = ({ data }) => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'DE EVENTE Services',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  return (
    <section className='DBlock py-10 sm:py-12 px-6 sm:px-10'>
      <div className='max-w-7xl mx-auto'>
        <TitleSection titleDetail={titleDetail} />
        <div className='DBlock'>
          <div className='max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6'>
            {data?.map((list) => (
              <div key={`cardList${list?.id}`}>
                <ServiceCard data={list} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
